if (!AFRAME.destory) {
	AFRAME.destory = function() {
		var self = this;
		var debug = true;
		function disposeNode(node) {
			if (node instanceof THREE.Mesh) {
				if (debug == true) {
					console.log('Disposing of node: ' + node.name);
				}
				if (node.geometry) {
					node.geometry.dispose();
					node.geometry = undefined; // fixed problem
				}
				if (node.material) {
					if (
						node.material instanceof THREE.MeshFaceMaterial ||
						node.material instanceof THREE.MultiMaterial
					) {
						node.material.materials.forEach(function(mtrl, idx) {
							if (mtrl.map) mtrl.map.dispose();
							if (mtrl.lightMap) mtrl.lightMap.dispose();
							if (mtrl.bumpMap) mtrl.bumpMap.dispose();
							if (mtrl.normalMap) mtrl.normalMap.dispose();
							if (mtrl.specularMap) mtrl.specularMap.dispose();
							if (mtrl.envMap) mtrl.envMap.dispose();
							mtrl.dispose();
							mrtl = undefined; // fixed problem
						});
					} else {
						if (node.material.map) {
							node.material.map.dispose();
							node.material.map.image = undefined;
						}
						if (node.material.lightMap) {
							node.material.lightMap.dispose();
							node.material.lightMap.image = undefined;
						}
						if (node.material.bumpMap) {
							node.material.bumpMap.image = undefined;
							node.material.bumpMap.dispose();
						}
						if (node.material.normalMap) {
							node.material.normalMap.image = undefined;
							node.material.normalMap.dispose();
						}
						if (node.material.specularMap) {
							node.material.specularMap.image = undefined;
							node.material.specularMap.dispose();
						}
						if (node.material.envMap) {
							node.material.envMap.image = undefined;
							node.material.envMap.dispose();
						}
						if (node.material.roughnessMap) {
							node.material.roughnessMap.image = undefined;
							node.material.roughnessMap.dispose();
						}
						node.material.map = undefined;
						node.material.lightMap = undefined;
						node.material.bumpMap = undefined;
						node.material.normalMap = undefined;
						node.material.specularMap = undefined;
						node.material.envMap = undefined;
						node.material.roughnessMap = undefined;
						node.material.dispose();
						node.material = undefined; // fixed problem
					}
				}
			}
			node.parent.remove(node);
			node = undefined; // unnecessary
		}
		function disposeHierarchy(node, callback) {
			for (var i = node.children.length - 1; i >= 0; i--) {
				var child = node.children[i];
				disposeHierarchy(child, callback);
				if (callback) callback(child);
			}
		}
		var ascene = AFRAME.scenes[0];
		disposeHierarchy(ascene.object3D, disposeNode);
		ascene.setAttribute('render-enabled', 'false');
	};
}

if (!AFRAME.components['render-enabled']) {
	AFRAME.registerComponent('render-enabled', {
		schema: { type: 'boolean', default: true },
		init() {
			const _this = this;
			this.renderEnabled = this.data;
			this.el.render = function render() {
				if (!this.clock) {
					return;
				}
				const delta = this.clock.getDelta() * 1000;
				const renderer = this.renderer;
				this.time = this.clock.elapsedTime * 1000;
				if (!_this.renderEnabled) {
					renderer.setAnimationLoop(null);
					return;
				}
				if (this.isPlaying) {
					this.tick(this.time, delta);
				}
				renderer.setAnimationLoop(this.render);
				renderer.render(this.object3D, this.camera, this.renderTarget);
				if (this.isPlaying) {
					this.tock(this.time, delta);
				}
			}.bind(this.el);
		},
		update() {
			this.renderEnabled = this.data;
			if (this.renderEnabled) {
				this.el.render();
			}
		},
		remove() {
			this.el.renderer.forceContextLoss();
			this.el.renderer.context = undefined;
			this.el.renderer.dispose();
			this.el.renderer = undefined;
		}
	});
}
